import React, { useEffect, useState } from 'react';
import { IDocument } from '../Interfaces/IDocument';
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useGetLegalClients } from '../hooks/reactQuerys/LegalClientQueries';
import { useGetDownloadedDocuments } from '../hooks/reactQuerys/DocumentQueries';

interface IProps {
  documentObject: IDocument;
}

export const DocumentDownloaded: React.FC<IProps> = ({ documentObject }) => {
  const { legalClients, isLoadingLegalClients } = useGetLegalClients();
  const { downloadedDocuments, isLoadingDownloadedDocuments } =
    useGetDownloadedDocuments();

  const [uniquideIdContactArray, setUniquideIdContactArray] = useState<
    number[]
  >([]);

  const timeStringWithoutTimezone = (currentDate: Date) => {
    const userTimezoneOffset = currentDate.getTimezoneOffset() * 60000;
    return new Date(
      currentDate.getTime() + userTimezoneOffset
    ).toLocaleString();
  };

  useEffect(() => {
    if (legalClients && downloadedDocuments) {
      const tmpArray = [
        ...downloadedDocuments
          .filter(document => document.idDocument === documentObject.idDocument)
          .map(document => document.idLegalClient),
      ];
      const unique = tmpArray.filter(
        (value, index, array) => array.indexOf(value) === index
      );
      setUniquideIdContactArray([...unique]);
    }
  }, [legalClients, downloadedDocuments]);

  if (isLoadingLegalClients || isLoadingDownloadedDocuments) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='30vh'
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!legalClients || !downloadedDocuments) {
    return <>Error</>;
  }

  return (
    <>
      <Typography>
        Das Dokument <i>{documentObject.FileName}</i> wurde insgesamt{' '}
        {
          downloadedDocuments.filter(
            document => document.idDocument === documentObject.idDocument
          ).length
        }{' '}
        runtergeladen:
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Mandant</TableCell>
              <TableCell>Frühster Download</TableCell>
              <TableCell>Spätester Download</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {uniquideIdContactArray.map(localIdContact => {
              const currentContact = legalClients.find(
                contact => contact.idLegalClient === localIdContact
              );
              const ownDownloaded = downloadedDocuments
                .filter(
                  document => document.idDocument === documentObject.idDocument
                )
                .filter(document => document.idLegalClient === localIdContact);

              return (
                <TableRow>
                  <TableCell>
                    {currentContact?.FirstName} {currentContact?.LastName}
                  </TableCell>
                  <TableCell>
                    {ownDownloaded.length > 0 ? (
                      timeStringWithoutTimezone(
                        new Date(ownDownloaded[0].Timestamp)
                      )
                    ) : (
                      <>k.A.</>
                    )}
                  </TableCell>
                  <TableCell>
                    {ownDownloaded.length > 0 ? (
                      timeStringWithoutTimezone(
                        new Date(
                          ownDownloaded[ownDownloaded.length - 1].Timestamp
                        )
                      )
                    ) : (
                      <>k.A.</>
                    )}
                  </TableCell>
                  <TableCell>{ownDownloaded.length}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Typography>
    </>
  );
};
